export default __webpack_public_path__ + "static/media/Sage's Gauntlets of the Crumbling Tower.be5bb029.jpg";